import React, { useEffect, useMemo, useState, } from 'react';
import { Dimensions, StyleSheet, Text, TouchableOpacity, View, ScrollView, Platform } from 'react-native';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeTokens, } from '@voltmoney/schema';
import AssetDetails from '../AssetDetails';
import ThemeProvider from '@voltmoney/theme';
import { ModalAlignmentEnum, SCREEN_SIZE, } from '@voltmoney/types';
import BottomSheet from '../BottomSheet';
import { Typography } from '../../typography/Typography';
import { Icon } from '../../icon/Icon';
import { Space } from '../../space/Space';
import LottieView from 'lottie-react-native';
import { Button } from '../../button/Button';
import { Header } from '../../header/Header';
import { isMobile } from '../../stack/utils';
import { AppBottomNav } from '../../appBottomNav/AppBottomNav';
import { addCommasToNumber } from '../utils';
import CustomHeader from "../../customHeader/CustomHeader";
const UnpledgeStatusPage = ({ bankData, profileAction, stepperData, triggerAction, backAction, applyAction, modalState, continuePress, userName, height, creditLimit, sanctionedAmount, needHelp, backButtonClicked }) => {
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null,
    };
    const [showModal, setShowModal] = useState(false);
    const [rupeeLottie, setRupeeLottie] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [cardState, setModalState] = useState('Penny');
    const [modalHeight, setModalHeight] = useState(332);
    const [selectedObject, setSelectedObject] = useState({});
    const [isDismissable, setDismissable] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [showDetails, setShowDetails] = useState(false);
    const [showToolTip, setShowToolTip] = useState(false);
    const theme = ThemeProvider.getTheme();
    let bgColor = theme.colors[ColorTokens.Primary_100];
    useEffect(() => {
        if (modalState) {
            if (modalState === 'error') {
                setDismissable(true);
                setModalHeight(244);
            }
            if (modalState === 'success') {
                setModalHeight(228);
            }
            setModalState(modalState);
        }
        else {
            setModalState('Penny');
        }
    }, [modalState]);
    // @ts-ignore
    useEffect(() => {
        if (backButtonClicked) {
            if (showDetails) {
                setShowDetails(false);
            }
        }
    }, [backButtonClicked]);
    const _headerChild = () => {
        return (React.createElement(CustomHeader, { title: showDetails ? 'Unpledge request' : 'Track unpledge request', goBackAction: backAction, needHelpAction: needHelp, triggerAction: triggerAction, goBackId: "btn_trackUnpledge_goBack", needHelpId: "btn_trackUnpledge_needHelp" }));
    };
    const renderInfoBox = () => {
        return (React.createElement(TouchableOpacity, { style: {
                padding: 16,
                zIndex: 1,
            }, activeOpacity: 1, onPress: () => {
                setShowToolTip(false);
            } },
            React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, label: 'Credit Limit' }),
            React.createElement(View, { style: {
                    marginTop: 24,
                    borderColor: '#E4E7EC',
                    borderWidth: 1,
                    borderRadius: 8,
                    padding: 12,
                } },
                React.createElement(View, { style: {
                        marginTop: 16,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(Typography, { label: 'Credit limit against portfolio', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(creditLimit), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(View, { style: { flexDirection: 'row' } },
                            React.createElement(Typography, { label: 'Max loan amount sanctioned', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal }),
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    setShowToolTip(true);
                                } },
                                React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.LG }),
                                showToolTip && (React.createElement(Text, { style: styles.tooltip }, "This is the max sanctioned loan amount approved as per your loan agreement, it can be revised by doing another agreement by increasing your limit.")))),
                        React.createElement(View, { style: {
                                borderStyle: 'dashed',
                                borderWidth: 1,
                                borderColor: '#667085',
                            } })),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(sanctionedAmount), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: {
                        height: 1,
                        width: '100%',
                        backgroundColor: '#E4E7EC',
                        marginTop: 16,
                    } }, ' '),
                React.createElement(View, { style: {
                        marginTop: 16,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Credit limit', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Night })),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(creditLimit), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Secondary_100 })))));
    };
    const renderInvalidIfscContent = () => {
        return (React.createElement(View, { style: {
                justifyContent: 'center',
                padding: 16,
                alignItems: 'center',
                flex: 1,
            } },
            React.createElement(LottieView, { source: rupeeLottie, style: { width: 99, height: 95 }, autoPlay: true, loop: true }),
            React.createElement(Typography, { label: 'Depositing ₹1', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, paddingTop: 32 }),
            React.createElement(View, { style: {
                    width: '100%',
                    backgroundColor: '#FEF4E6',
                    padding: 16,
                    marginTop: 32,
                } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, fontFamily: FontFamilyTokens.Inter, label: 'You will be required to download & submit a signed copy of mandate form.' })),
            React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
                React.createElement(Typography, { label: 'It may take up to 27 seconds...' }))));
    };
    const renderBankCard = (item) => {
        return (React.createElement(TouchableOpacity, { onPress: () => {
                if (selectedValue === item.accountNumber) {
                    setSelectedValue('');
                    setSelectedObject({});
                }
                else {
                    setSelectedValue(item.accountNumber);
                    setSelectedObject(item);
                }
            }, style: {
                borderColor: item.accountNumber === selectedValue
                    ? bgColor
                    : '#E4E7EC',
                borderWidth: 1,
                flexDirection: 'row',
                paddingTop: 15,
                paddingLeft: 12,
                paddingRight: 12,
                paddingBottom: 12,
                marginBottom: 12,
                borderRadius: 4,
                width: '100%',
                backgroundColor: item.accountNumber === selectedValue
                    ? '#FAFBFE'
                    : 'white',
            } },
            React.createElement(View, { style: { flexDirection: 'row', flex: 1 } },
                React.createElement(View, { style: {
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                    } },
                    React.createElement(View, { style: {
                            height: 4,
                        } }),
                    React.createElement(Icon, { name: item.accountNumber === selectedValue
                            ? IconTokens.RadioCircleFilled
                            : IconTokens.RadioCircleNotFilled, size: IconSizeTokens.MD })),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(View, { style: { flexDirection: 'column' } },
                    React.createElement(Typography, { label: item.bankName, color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, paddingTop: 0 }),
                    React.createElement(Space, { size: SizeTypeTokens.SM }),
                    React.createElement(Typography, { label: 'XXXX ' + item.accountNumber.slice(-4), type: TypographyTypeTokens.B6, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24, paddingTop: 0 }))),
            React.createElement(View, { style: { flexDirection: 'row' } },
                React.createElement(Space, { size: SizeTypeTokens.XXXL }))));
    };
    const convertEpochToDate = (timeStamp) => {
        const date = new Date(timeStamp);
        // Define an array of month names
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        // Extract the day, month, and year from the date
        const day = date.getDate();
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        // Create the formatted date string
        const formattedDate = `${day} ${month}, ${year}`;
        return formattedDate;
    };
    const calculateSumOfAssetPledgedValue = (assets) => {
        let sum = 0;
        for (const asset of assets) {
            sum += asset.assetPledgedValue;
        }
        return Math.floor(sum);
    };
    const modalContentPresenter = () => {
        return renderInfoBox();
    };
    useEffect(() => {
        //https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json
        return () => {
            setModalHeight(332);
            setModalState('Penny');
            setShowModal(false);
        };
    }, []);
    const renderEmptyState = () => {
        return (React.createElement(View, { style: [
                styles.blankContainer,
                { height: height },
            ] },
            React.createElement(View, { style: {
                    width: '100%',
                    marginHorizontal: -16,
                } },
                React.createElement(Header, { type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: 'Link bank account', onPress: () => {
                        if (backAction) {
                            triggerAction(backAction);
                        }
                    } })),
            React.createElement(View, { style: {
                    marginTop: 24,
                    alignItems: 'flex-start',
                    alignSelf: 'flex-start',
                } },
                React.createElement(Typography, { label: 'Add bank account for receiving cash', fontWeight: 'bold', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins })),
            React.createElement(View, { style: {
                    bottom: 0,
                    position: 'absolute',
                    width: '100%',
                } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Add bank account', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (profileAction) {
                            triggerAction(profileAction);
                        }
                    } }))));
    };
    const _bodyChild = () => {
        const reqStr = bankData.length > 1 ? "requests" : "request";
        return (React.createElement(View, { style: { paddingLeft: 16, paddingRight: 16, paddingBottom: 16, paddingTop: 10 } },
            React.createElement(Typography, { label: bankData.length.toString() + " " + reqStr, fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24, color: ColorTokens.Grey_Night }),
            React.createElement(ScrollView, { contentContainerStyle: { paddingBottom: 70 } }, bankData.map((bank) => {
                return (React.createElement(View, null,
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: `Date of request ${convertEpochToDate(bank.createdOn)}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: ColorTokens.Grey_Night })),
                    renderStatusBox(bank)));
            }))));
    };
    const _detailBodyChild = () => {
        return (React.createElement(View, { style: { padding: 16 } },
            React.createElement(Typography, { label: 'Request details', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24, color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 16, borderColor: '#E4E7EC', borderWidth: 1, borderRadius: 8 } },
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                        paddingHorizontal: 12
                    } },
                    React.createElement(Typography, { label: 'Date of request', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: convertEpochToDate(selectedItem.createdOn), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '500', color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                        paddingHorizontal: 12
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Value', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night })),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: '₹' + addCommasToNumber(selectedItem.totalValueOfUnpledgedAssets), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '500', color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                        paddingHorizontal: 12
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Status', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            paddingLeft: 12,
                            paddingRight: 12,
                            paddingTop: 2,
                            paddingBottom: 2,
                            backgroundColor: '#FEF4E6',
                            borderRadius: 4
                        } },
                        React.createElement(Typography, { label: "PENDING", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXS, lineHeight: 16, fontWeight: '500', color: ColorTokens.CINNAMON }))),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: '#E4E7EC', marginTop: 12 } })),
            React.createElement(View, { style: {
                    height: 16,
                    backgroundColor: '#E4E7EC',
                    marginTop: 16,
                    marginBottom: 16,
                    marginHorizontal: -16
                } }),
            React.createElement(View, { style: { marginLeft: 16 } },
                React.createElement(Typography, { label: 'List of unpledged MFs', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(ScrollView, { style: { flex: 1, paddingBottom: 16 } },
                React.createElement(AssetDetails, { data: [], 
                    // @ts-ignore
                    dataa: selectedItem.collateralDetailList, 
                    // @ts-ignore
                    flatData: selectedItem.collateralDetailList, onFitlerSet: () => {
                    }, isFromEligible: true, triggerAction: triggerAction, hideFilter: true, height: height }))));
    };
    const renderStatusBox = (bankData) => {
        // @ts-ignore
        return (React.createElement(View, null,
            React.createElement(View, { style: { marginTop: 12, borderColor: '#E4E7EC', borderWidth: 1, borderRadius: 8 } },
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                        paddingHorizontal: 12
                    } },
                    React.createElement(Typography, { label: 'Request type', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night }),
                    React.createElement(Typography, { label: "Unpledge request", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '500', color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                        paddingHorizontal: 12
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Value', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night })),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: '₹' + addCommasToNumber(bankData.totalValueOfUnpledgedAssets), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '500', color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                        paddingHorizontal: 12
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Application status', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            paddingLeft: 12,
                            paddingRight: 12,
                            paddingTop: 2,
                            paddingBottom: 2,
                            backgroundColor: '#FEF4E6',
                            borderRadius: 4
                        } },
                        React.createElement(Typography, { label: "PENDING", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXS, lineHeight: 16, fontWeight: '500', color: ColorTokens.CINNAMON }))),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: '#E4E7EC', marginTop: 12 } }),
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(View, { style: { alignItems: 'center', alignContent: 'center', borderColor: '#E4E7EC' } },
                        React.createElement(TouchableOpacity, { style: { padding: 12 }, onPress: () => {
                                setSelectedItem(bankData);
                                setShowDetails(true);
                            } },
                            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 20, fontSize: FontSizeTokens.SM, color: ColorTokens.Primary_100, label: "View details >" })))))));
    };
    const _footerChild = useMemo(() => {
        return (React.createElement(View, { style: {
                width: '100%',
            } },
            React.createElement(AppBottomNav, { currentRoute: 'MANAGE_LIMIT', navigationAction: continuePress, triggerAction: triggerAction })));
    }, []);
    const renderMainBody = () => {
        return (React.createElement(View, { style: [styles.container, { height: Platform.OS === "ios" ? height - 8 : height }] },
            React.createElement(View, { style: {
                    flex: 1,
                } },
                React.createElement(View, { style: { marginTop: Platform.OS === "ios" ? 4 : 0 } }, _headerChild()),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(ScrollView, { nestedScrollEnabled: true }, showDetails ? _detailBodyChild() : _bodyChild()))),
            showModal && (React.createElement(View, { style: {
                    overflow: 'hidden',
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: 240, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').height - 70
                        : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').width
                        : 504, routeId: 'routeId', handleKeyboard: true }, modalContentPresenter())))));
    };
    return renderMainBody();
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        marginHorizontal: -16,
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        width: '100%',
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        padding: 16,
        flex: 1, // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    groupContainer: {
        zIndex: 0,
    },
    groupLayout: {
        height: 88,
        width: '100%',
        borderRadius: 16,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    footer: {
        position: 'absolute',
        bottom: '0',
        zIndex: 99,
        width: '100%',
        // backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        // shadowColor: '#D0D5DD',
        // shadowOffset: { width: 0, height: 1 },
        // shadowOpacity: 0.25,
        // shadowRadius: 6,
        // elevation: 2,
        backgroundColor: 'rgb(255, 255, 255)',
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowOpacity: 0.5,
    },
    frameGroup: {
        borderRadius: 8,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowRadius: 8,
        elevation: 8,
        borderColor: '#e4e7ec',
        paddingBottom: 61,
        marginTop: 16,
        borderStyle: 'solid',
        shadowOpacity: 1,
        shadowOffset: {
            width: 0,
            height: 2,
        },
    },
    tooltip: {
        position: 'absolute',
        backgroundColor: '#667085',
        color: 'white',
        padding: 16,
        borderRadius: 5,
        width: 272,
        bottom: '100%',
        left: '50%',
        transform: [{ translateX: -150 }],
    },
});
export default UnpledgeStatusPage;
